import * as React from 'react';
import LoadingInView from 'core/components/LoadingInView';

export type LoadFn<Props> = () => Promise<{
    default: React.ComponentType<Props>;
}>;

export default function loadable<Props>(
    factory: LoadFn<Props>,
): React.FunctionComponent<Props> {
    const LazyComponent = React.lazy<React.ComponentType<Props>>(factory);

    return function WrapperComponent(props: Props) {
        return (
            <React.Suspense fallback={<LoadingInView delay={200} />}>
                <LazyComponent {...props} />
            </React.Suspense>
        );
    };
}
